<template>
  <div
      v-if="show"
      class="full-screen-progress"
      @click.stop.prevent="handleClick"
  >
    <img width="300px" height="300px" style="horiz-align: center" :src="QRCodeData" alt=""/>
    <div class="progress-bar-container">
      <div class="progress-bar" :style="{ width: progress + '%' }"></div>
    </div>
    <span style="font-size: 20px;height: 40px;margin-top: 10px;color: blue">{{ ShowMessage }}</span>
  </div>
</template>

<script>
export default {
  props: {
    ShowMessage: '',
    QRCodeData: null,
    show: Boolean,
    progress: Number
  },
  methods: {
    handleClick() {
      // 阻止点击事件传递到父元素
    }
  }
};
</script>

<style scoped>
.full-screen-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column; /* 设定子元素水平排列 */
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.progress-bar-container {
  width: 80%;
  height: 10px;
  background-color: #f3f3f3;
  border-radius: 5px;
  margin-top: 20px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #4caf50;
}
</style>
